import { useSelectorApp } from "../../lib/redux";
import { Navigate, useLocation } from "react-router-dom";
import { OWNER_ROLE } from "../../utils/constants";
import { useDefaultAppRoute } from "../../hooks/useIsAdvertisersDemo";

export const OwnerRoute = ({ children, isLogged }) => {
  const location = useLocation();
  const { user } = useSelectorApp((state) => state.auth);
  const defaultRoute = useDefaultAppRoute();

  if (!isLogged) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== OWNER_ROLE) {
    return <Navigate to={defaultRoute} replace />;
  }

  return children;
};
